


































































































import { MD5 } from 'crypto-js';
import { dateMonthYearFormat } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { DISCOUNT_TYPE, OFFER_TYPE } from '@/store/shared';
import FeedbackShare from '@/components/CancelAnalytics/FeedbackShare.vue';
import { ISession } from '@/store/types';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'FeedbackCard',
  mixins: [CopyToClipboard],
  components: {
    FeedbackShare,
  },
  props: {
    session: {
      type: Object as PropType<ISession>,
    },
    feedbackGroup: {
      type: Object as PropType<{ shortLabel: string; bgColor: string; iconColor: string }>,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      dateMonthYearFormat,
      showShare: false,
    };
  },
  computed: {
    ...mapGetters(['confidential']),
  },
  methods: {
    generateGravatarUrl(email: string) {
      const trimmedEmail = (email || '').trim();
      const lowerCaseEmail = trimmedEmail.toLowerCase();
      const hash = MD5(lowerCaseEmail).toString();
      return `https://www.gravatar.com/avatar/${hash}?s=200&d=retro`;
    },
  },
});
